import {
  getEstablishment,
  getEstablishments,
  requestEstablishment,
  requestNetworkEstablishment,
} from '@/common/integrations/menhir/employee/establishments/establishments.services';
import {
  EstablishmentNetworkType,
  IEstablishment,
  INetworkEstablishmentRequest,
  TRequestEstablishmentParam,
} from '@/common/integrations/menhir/employee/establishments/establishments.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

export function useGetEstablishments(
  establishmentTypeFilters: EstablishmentNetworkType[],
  options?: UseQueryOptions<IEstablishment[]>
) {
  const { data: establishments, ...rest } = useQuery({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.ESTABLISHMENTS.ROOT,
      ...establishmentTypeFilters,
    ],
    queryFn: () => getEstablishments(...establishmentTypeFilters),
    ...options,
  });

  return { establishments, ...rest };
}

export function useGetEstablishment(
  id: string,
  options?: UseQueryOptions<IEstablishment>
) {
  const { data: establishment, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.ESTABLISHMENTS.DETAIL, id],
    queryFn: () => getEstablishment(id),
    ...options,
  });
  return { establishment, ...rest };
}

export function useRequestEstablishment(
  options?: UseMutationOptions<any, unknown, TRequestEstablishmentParam>
) {
  return useMutation({
    mutationFn: requestEstablishment,
    ...options,
  });
}

export function useRequestNetworkEstablishment(
  options?: UseMutationOptions<any, unknown, INetworkEstablishmentRequest>
) {
  return useMutation({
    mutationFn: requestNetworkEstablishment,
    ...options,
  });
}
